import Vue from 'vue'
import store from '@packages/store'

export default {

    async load({pagination, filters}) {
        const codes = await Vue.api.promocionalcode.load({pagination, filters})

        store.commit('SET_PROMOCIONALCODE_LIST', codes)

        return codes
    },

    async count({filters}) {
        const count = await Vue.api.promocionalcode.count({filters})

        store.commit('SET_PROMOCIONALCODE_COUNT', count)

        return count
    },

}

